import { useIsRestoring } from '@tanstack/react-query'

export default function PersistentGate({ children }: { children: React.ReactNode }) {
  const isRestoring = useIsRestoring()

  if (isRestoring) {
    return <div>Loading cached data...</div>
  }

  return <>{children}</>
}
